@if(service.viewDroplistItems.length){
<div class='delivery-overview-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem' (selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort' style='display:inline-block'> </droplist>
	@switch (selectedViewItem.uniqueId) {
	<!-- @case (service.viewId.Overview) {
	<delivery-overview-view-part></delivery-overview-view-part>
	} -->
	@case (service.viewId.AllVentures) {
	<delivery-all-ventures-view-part></delivery-all-ventures-view-part>
	}
	@case (service.viewId.AllEntrepreneurs) {
	<delivery-all-entrepreneurs-view-part></delivery-all-entrepreneurs-view-part>
	}
	@case (service.viewId.AllMentors) {
	<delivery-all-mentors-view-part></delivery-all-mentors-view-part>
	}
	@case (service.viewId.VentureDropouts) {
	<delivery-venture-dropouts-view-part></delivery-venture-dropouts-view-part>
	}
	@case (service.viewId.MentorDropouts) {
	<delivery-mentor-dropouts-view-part></delivery-mentor-dropouts-view-part>
	}
	@case (service.viewId.SessionFeedback) {
	<delivery-session-feedback-view-part></delivery-session-feedback-view-part>
	}
	@case (service.viewId.TopicFeedback) {
	<delivery-topic-feedback-view-part></delivery-topic-feedback-view-part>
	}
	@case (service.viewId.SpecialistFeedback) {
	<delivery-specialist-feedback-view-part></delivery-specialist-feedback-view-part>
	}
	@case (service.viewId.AllAwards) {
	<delivery-all-awards-view-part></delivery-all-awards-view-part>
	}
	}
	}
</div>
}